import React, { Component, Fragment } from 'react';
import { Label } from 'semantic-ui-react'
import ConfirmationModal from './modals/ConfirmationModal'

class RemoveEntryLabel extends Component {
  state = { modalOpen: false }

  handleRemove = (test) => {
    test && this.props.handleRemove(this.props.id)
    this.setState({modalOpen: false})
  }

  render = () => (
    <Fragment>
        <ConfirmationModal
          isOpen={this.state.modalOpen}
          question={this.props.question}
          onConfirmation={(test) => this.handleRemove(test)}
        />
        <Label
          basic
          color='red'
          floating
          size='mini'
          style={{ cursor: 'pointer' }}
          onClick={() => this.setState({
            modalOpen: true
          })}
          >
            X
        </Label>
      </Fragment>
  )
}

export default RemoveEntryLabel;


// WEBPACK FOOTER //
// ./src/component/RemoveEntryLabel.js